import React, { lazy } from 'react';
import Suspense from '../layout/Suspense';

const LazyComponent = lazy(() => import('./ForgotPassword'));

export default () => {
  return <Suspense lazyComponent={<LazyComponent />} />;
};
